<template>
  <section class="wrapper">
    <h1>Согласно постановлению №410 от 14.05.2013</h1>
    <p>10. Замена оборудования, входящего в состав внутридомового и (или) внутриквартирного газового оборудования, осуществляется в следующих случаях: <br><br>
      - истечение нормативных сроков эксплуатации оборудования, установленных изготовителем, или сроков эксплуатации оборудования, установленных проектной документацией, утвержденной в отношении газопроводов, если эти сроки не продлены по результатам технического диагностирования внутридомового и (или) внутриквартирного газового оборудования, а также истечение сроков эксплуатации этого оборудования, продленных по результатам его технического диагностирования; <br><br>
      - признание газоиспользующего оборудования не подлежащим ремонту (непригодным для ремонта) в ходе технического обслуживания либо по результатам технического диагностирования внутридомового и (или) внутриквартирного газового оборудования; <br><br>
      - заявка заказчика. <br><br>
      Замена оборудования, входящего в состав внутридомового и (или) внутриквартирного газового оборудования, осуществляется специализированной организацией в рамках исполнения договора о техническом обслуживании и ремонте внутридомового и (или) внутриквартирного газового оборудования.
      <span>Самостоятельная замена указанного оборудования его владельцем без привлечения специализированной организации не допускается.</span>
    </p>
    <h1>Алгоритм замены котла</h1>
    <ol>
      <li> Котел заменяется на аналогичный без изменения его технических данных.
        Замена осуществляется в рамках Договора ТО специализированной организацией по заявке заказчика. По результатам выдается Акт о замене.
      </li>
      <li> Котёл заменяется с изменениями в составе газоиспользующего оборудования либо его технических данных. В таком случае
        необходимо внести изменения  в проект и согласовать их с поставщиком газа;
        затем заключить Договор со специализированной организацией по замене оборудования.
      </li>
    </ol>
    <p style="text-align: center">
      <img src="../img/boiler-change.webp" alt="рабочие меняют котёл">
    </p>
  </section>
</template>

<script>
  export default {

  }
</script>

<style scoped>

img {
  width: 50%;
  height: auto;
}

span {
  color: red;
  font-weight: 700;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h1  {
  text-align: center;
  font-family: "Poppins", sans-serif !important;
  font-size: 3em;
}

p {
  text-align: justify;
  font-size: 2em;
  padding: 20px;
  margin-left: 5%;
  margin-right: 5%;
}

ol li{
  font-size: 2em;
  padding: 20px;
  text-align: justify;
  margin-right: 5%;
  margin-left: 5%;

}

@media (max-width: 1400px) {

  h1 {
    margin-left: 5%;
    margin-right: 5%;
  }

  img {
    width: 100%;
  }
}

@media (max-width: 800px) {
  h1 {
    font-size: 1.8em;
  }

  p {
    font-size: 1.2em;
    padding: 10px;
  }

  ol li {
    font-size: 1.2em;
    padding: 10px;
  }
}

@media (max-width: 400px) {

  h1 {
    font-size: 1.4em;
  }

  p {
    font-size: 0.8em;
    padding: 10px;
  }

  ol li {
    font-size: 0.8em;
    padding: 10px;
  }
}

</style>